import { useEffect } from "react";
import ScrollReveal from 'scrollreveal';

const Contact = () => {
    useEffect(()=>{

        const scroll = ScrollReveal({
            origin: "top",
            distance: "5rem",
            duration: 2000,
            reset: true
        })

        scroll.reveal(".contact__input",{ delay: 600, interval: 500})
    },[]) 
    
    return (
        <section id='contact'>
            <div className='contact container'>
                <h1 className='section-title'>
                    Contact <span>info</span>
                </h1>
                <div className='contact__container bg-grid'>
                    <form
                        className='contact__form'
                        action='https://formsubmit.co/solomonnjobvu3@gmail.com'
                        method='POST'
                    >
                        <div>
                            <label htmlFor='name'>Name</label>
                            <input
                                type='text'
                                name='name'
                                placeholder='Name'
                                className='contact__input'
                                required
                            />

                            <input
                                type='hidden'
                                name='_subject'
                                value='This is Email its comming from your Portfolio'
                            />
                        </div>

                        <div>
                            <label htmlFor='email'>Email</label>

                            <input
                                type='email'
                                name='email'
                                placeholder='letsworktogether@example.com'
                                className='contact__input'
                                required
                            />
                        </div>

                        <div>
                            <label htmlFor='message'>Message</label>

                            <textarea
                                type='text'
                                name='message'
                                placeholder='Lets work together!'
                                cols='0'
                                rows='10'
                                className='contact__input'
                                required
                            ></textarea>
                        </div>

                        <input
                            type='submit'
                            value='send'
                            className='send btn'
                        />
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Contact;
